import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/leadStatusSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

export function DatePicker() {
  const dispatch = useDispatch();

  const dateFormat = useDateFormat();

  const { calendarStartDate, calendarEndDate } = useSelector(
    (state) => state.leadStatus.currentUser
  );

  const { startDate, endDate } = useSelector((state) => state.leadStatus.selectedFilters.dates);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      showDefaultInputIcon={false}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
}
